module.exports = __webpack_public_path__ + "img/card_inhalt.6e8d9cc3.jpg";